export class UserData {

    private firstname: string;
    private internalId: string;
    private lastname: string;
    private userImage: string;
    private username: string;

    constructor(firstname?: string, internalId?: string, lastname?: string, userImage?: string, username?: string) {
        this.firstname = firstname;
        this.internalId = internalId;
        this.lastname = lastname;
        this.userImage = userImage;
        this.username = username;
    }

    public get Firstname() {
        return this.firstname;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get Lastname() {
        return this.lastname;
    }
    public get UserImage() {
        return this.userImage;
    }
    public get Username() {
        return this.username;
    }

    public set Firstname(firstname) {
        this.firstname = firstname;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Lastname(lastname) {
        this.lastname = lastname;
    }
    public set UserImage(userImage) {
        this.userImage = userImage;
    }
    public set Username(username) {
        this.username = username;
    }

}
